module.exports = __webpack_public_path__ + "static/img/img-home-co-05.5a58996.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-co-05.png
// module id = eBSI
// module chunks = 1